import { isShiftXUrl } from './shiftxUtils';
import { ensureAbsolutePathUrl, escapeJavascriptColon } from './stringUtils';

export const processUrl = (url: unknown) =>
  ensureAbsolutePathUrl(escapeJavascriptColon(url));

export const maybeRelativeUrl = (val: string, relative: boolean) =>
  relative ? val : processUrl(val);

export const sanitizeUrl = (url: string) => {
  return url.replace(/[^-A-Za-z0-9+&@#/%?=~_|!:,.;()]/g, '');
};

export const isValidRedirectUrl = (
  url: string,
  origin: string,
  logError?: (
    error: Error,
    msg: string,
    extra: Record<string | number, unknown>
  ) => void
) => {
  if (!url) {
    return false;
  }
  try {
    const newUrl = new URL(url, origin);
    return newUrl.origin === origin;
  } catch (e) {
    const error = new Error(e as string);
    if (logError) {
      logError(error, 'Invalid redirect URL', {
        invalidRedirectUrl: url,
        errorMessage: error.message,
      });
    }
    return false;
  }
};

export const getRedirectTarget = (
  search: string,
  origin: string
): string | null => {
  const url = new URLSearchParams(search).get('url');
  if (!url || !isValidRedirectUrl(url, origin)) {
    return null;
  }
  return url;
};

export const openUrlInNewTab = (targetURL: string) => {
  window.open(
    maybeRelativeUrl(targetURL, isShiftXUrl(targetURL)),
    '_blank',
    'noopener'
  );
};
